import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Callback from '../views/Callback.vue'
import Error from '../views/Error.vue'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import { store }  from '@/store/index.js'
import {loginRequest, msalInstance} from "@/adAuth-config"
import {computed} from "vue"



const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Home',
      isPublic: true,
      requiresAuth: false // Public route
    }
  },
  {
    path: '/one-product-mode',
    name: 'OneProductMode',
    meta: {
      title: 'One Product Search',
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "one-product-mode" */ '../views/OneProductMode')
  },
  {
    path: '/one-product-mode/ov',
    name: 'OneProductMode Ov',
    meta: {
      title: 'One Product Search Operational Variables',
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "one-product-mode" */ '../views/OneProductMode/operationalVariables')
  },
  {
    path: '/one-product-mode/dxc',
    name: 'OneProductMode Diagnostic Codes',
    meta: {
      title: 'One Product Search Diagnostic Codes',
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "one-product-mode" */ '../views/OneProductMode/diagnosticCodes')
  },
  {
    path: '/one-product-mode/pv',
    name: 'OneProductMode Periodised Variables',
    meta: {
      title: 'One Product Search  Periodised Variables',
      requiresAuth: true
    },
    component: () => import(/* webpackChunkName: "one-product-mode" */ '../views/OneProductMode/periodisedVariables')
  },
  {
    path: '/report-creation',
    name: 'ReportCreation',
    meta: {
      title: 'Report Creation',
      requiresAuth: true
    },
    // route level code-splitting
    // this generates a separate chunk (report-creation.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "report-creation" */ '../views/ReportCreation')
  },
  {
    path: '/report-creation/streamline-method',
    name: 'DTCStreamlinedQueries',
    meta: {
      title: 'DTC Grouping',
      requiresAuth: true
    },
    // route level code-splitting
    // this generates a separate chunk (report-creation.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "report-creation" */ '../views/ReportCreation/DTCStreamlinedQueries')
  },
  {
    path: '/report-creation/modular-queries',
    name: 'ModularQueries',
    meta: {
      title: 'Modular Queries',
      requiresAuth: true
    },
    // route level code-splitting
    // this generates a separate chunk (report-creation.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "report-creation" */ '../views/ReportCreation/ModularQueries')
  },
  {
    path: '/list-operational-data-variables',
    name: 'OperationalDataVariables',
    meta: {
      title: 'Operational Data Variables',
      requiresAuth: true
    },
    // route level code-splitting
    // this generates a separate chunk (operational-data-variables.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "operational-data-variables" */ '../views/OperationalDataVariables')
  },
  {
    path: '/logging-data-explorer',
    name: 'Logging Data Explorer',
    meta: {
      title: 'Logging Data Explorer',
      requiresAuth: true
    },
    component: () => import('../views/LoggingDataExplorer')
  },
  {
    path: '/test-product-diagnostics/under-construction',
    name: 'TestProductDiagnosticsUnderConstruction',
    meta: {
      title: 'Test Product Diagnostics Under Construction',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/UnderConstruction')
  },
  {
    path: '/test-product-diagnostics',
    name: 'TestProductDiagnostics',
    meta: {
      title: 'Test Product Diagnostics',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics')
  },

  {
    path: '/test-product-diagnostics/follow-up',
    name: 'TestProductDiagnosticsManualClassifications',
    meta: {
      title: 'Test Product Diagnostics Manual Classifications',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/Classifications/manualClassification')
  },
  {
    path: '/test-product-diagnostics/follow-up/dxcFilter',
    name: 'TestProductDiagnosticsManualClassificationsDxcFilter',
    meta: {
      title: 'Test Product Diagnostics Manual Classifications DTC/DEC Filter',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/Classifications/dxcFilter')
  },
  {
    path: '/test-product-diagnostics/follow-up/internalEventFilter',
    name: 'TestProductDiagnosticsManualClassificationsInternalEventFilter',
    meta: {
      title: 'Test Product Diagnostics Manual Classifications Internal Events Filter',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/Classifications/internalEventFilter')
  },
  {
    path: '/test-product-diagnostics/follow-up/readoutFilter',
    name: 'TestProductDiagnosticsManualClassificationsReadoutFilter',
    meta: {
      title: 'Test Product Diagnostics Manual Classifications Readout Filter',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/Classifications/readoutFilter')
  },
  {
    path: '/test-product-diagnostics/follow-up/readoutFilterEdit',
    name: 'TestProductDiagnosticsManualClassificationsReadoutFilterEdit',
    meta: {
      title: 'Test Product Diagnostics Manual Classifications Readout Filter Edit',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/Classifications/readoutFilterEdit')
  },
  {
    path: '/test-product-diagnostics/classifications/automatic',
    name: 'TestProductDiagnosticsAutomaticClassifications',
    params: true,
    meta: {
      title: 'Test Product Diagnostics Automatic Classifications',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/Classifications/automaticClassification')
  },
  {
    path: '/test-product-diagnostics/classifications/automatic/create',
    name: 'TestProductDiagnosticsCreateAutomaticClassifications',
    params: true,
    meta: {
      title: 'Test Product Diagnostics Create Automatic Classifications',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/Classifications/createAutomaticClassification')
  },
  {
    path: '/test-product-diagnostics/analytics/custom-reports',
    name: 'TestProductDiagnosticsVisualAnalytics',
    meta: {
      title: 'Test Product Diagnostics Visual Analytics',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/VisualAnalytics')
  },
  {
    path: '/test-product-diagnostics/analytics/create-report',
    name: 'Test Product Diagnostics Report Creation',
    meta: {
      title: 'Test Product Diagnostics Report Creation',
      requiresAuth: true
    },
    // route level code-splitting
    // this generates a separate chunk (report-creation.[hash].js) for this route
    // which is lazy-loaded when the route is visited.

    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/ReportCreation')
  },
  {
    path: '/test-product-diagnostics/admin/systems',
    name: 'Test Product Diagnostics Configured Systems',
    meta: {
      title: 'Test Product Diagnostics Configured Systems',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/SystemAdmin/configurableSystems')
  },
  {
    path: '/test-product-diagnostics/admin/products',
    name: 'Test Product Diagnostics Product Admin',
    meta: {
      title: 'Test Product Diagnostics Product Admin',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/ProductAmin/productAdmin')
  },
  {
    path: '/test-product-diagnostics/admin/products/edit-product',
    name: 'Test Product Diagnostics Edit Product Admin',
    params: true,
    meta: {
      title: 'Test Product Diagnostics Edit Product Admin',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/ProductAmin/editProductAdmin')
  },
  {
    path: '/test-product-diagnostics/system-admin/unconfigured-systems',
    name: 'Test Product Diagnostics Unconfigured Systems',
    meta: {
      title: 'Test Product Diagnostics Unconfigured Systems',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/SystemAdmin/unconfigurableSystems')
  },
  {
    path: '/test-product-diagnostics/admin/product-groups',
    name: 'Test Product Diagnostics Product-Group administration',
    meta: {
      title: 'Test Product Diagnostics Product Groups',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/ProductGroups/ProductGroups')
  },
  {
    path: '/test-product-diagnostics/admin/product-groups/edit-product-group',
    name: 'Test Product Diagnostics Edit-product group',
    props: true,
    meta: {
      title: 'Test Product Diagnostics Edit Product Groups',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/ProductGroups/EditProductGroup')
  },
  {
    path: '/test-product-diagnostics/admin/dxc',
    name: 'Test Product Diagnostics Edit DTC and DEC',
    props: true,
    meta: {
      title: 'Test Product Diagnostics Edit DTC and DEC',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/DXCAdmin/dxcAdmin')
  },
  {
    path: '/test-product-diagnostics/admin/edit-dxc',
    name: 'Test Product Diagnostics Edit DXC Admin',
    params: true,
    meta: {
      title: 'Test Product Diagnostics Edit DXC Admin',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/DXCAdmin/editDxcAdmin')
  },
  {
    path: '/test-product-diagnostics/request-readout',
    name: 'Test Product Diagnostics Request Readout',
    params: true,
    meta: {
      title: 'Test Product Diagnostics Request Readout',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/RequestReadout')
  },
  {
    path: '/test-product-diagnostics/request-readout2',
    name: 'Test Product Diagnostics Request Readout2',
    params: true,
    meta: {
      title: 'Test Product Diagnostics Request Readout2',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/RequestReadout2')
  },
  {
    path: '/test-product-diagnostics/map-analytics',
    name: 'Test Product Diagnostics Map Analytics',
    params: true,
    meta: {
      title: 'Test Product Diagnostics Map Analytics',
      requiresAuth: true
    },
    component: () => import('../views/ReportCreation/Reports/TestProductDiagnostics/MapAnalytics')
  },
  {
    path: '/callback',
    name: 'Callback',
    component: Callback,
    meta: {
      requiresAuth: false
    }  },
  {
    path: '/error',
    name: 'Error',
    component: Error,
    meta: {
      requiresAuth: false
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
  // linkExactActiveClass: 'exact-active-link'
})
// Initialize session timeout
// const sessionManager = setupSessionTimeout(router, msalInstance)
router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidc'))

router.beforeEach((to, from, next) => {
  const title = to.meta.title ? ' - ' + to.meta.title : ''
  document.title = 'Product Analytics' + title
  next()
})
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const adAuthenticated = msalInstance.getAllAccounts().length > 0
    const oidcAuthenticated = store.getters['oidc/oidcIsAuthenticated']

    if (!adAuthenticated && !oidcAuthenticated) {
      // Remember where the user intended to go, but do NOT trigger interactive Azure login automatically.
      // The user should initiate login via the Login button which will start OIDC, and the post-OIDC callback
      // will continue with Azure auth if needed.
      localStorage.setItem('redirectUrl', to.fullPath)
      return next('/')
    }

    return next()
  }
  next()
})
// Add a handler for the redirect callback
msalInstance.handleRedirectPromise()
  .then(response => {
    if (response) {
      console.log('Redirect callback handled')
      // Handle successful authentication
      return store.dispatch('oidc/authenticateOidc', true)
        .then(() => {
          localStorage.setItem('adTokenUpdate', Date.now())
          localStorage.setItem('sasTokenUpdate', Date.now())
          console.log('Authenticated with AzureAD and SAS')

        })
    }
  })
  .catch(error => {
    console.error('Handle redirect error:', error)
  })

export default router


